(function () {
  const nameInput = document.getElementById('patc-dog-name');
  const hiddenProp = document.getElementById('patc-dog-name-prop');
  const PATCH_HANDLE = 'custom-name-patch';

  let patchVariantId = null;
  let patchAddedToCart = false;
  let debounceTimer;

  fetch(`/products/${PATCH_HANDLE}.js`)
    .then(res => res.json())
    .then(product => {
      patchVariantId = product.variants[0].id;
    })
    .catch(err => console.error('Could not load name patch product:', err));

  nameInput.addEventListener('input', function () {
    const dogName = this.value.trim();
    if (hiddenProp) hiddenProp.value = dogName;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (dogName !== '') {
        addPatchToCart(dogName);
      } else {
        removePatchFromCart();
      }
    }, 500);
  });

  function addPatchToCart(dogName) {
    if (!patchVariantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: patchVariantId,
        quantity: 1,
        properties: {
          "Dog's Name": dogName
        }
      })
    })
      .then(res => res.json())
      .then(() => {
        patchAddedToCart = true;
        updateCartNote(dogName);
        document.body.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(err => console.error('Error adding name patch:', err));
  }

  function removePatchFromCart() {
    if (!patchVariantId || !patchAddedToCart) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: patchVariantId,
        quantity: 0
      })
    })
      .then(res => res.json())
      .then(() => {
        patchAddedToCart = false;
        updateCartNote('');
        document.body.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(err => console.error('Error removing name patch:', err));
  }

  function updateCartNote(dogName) {
    const noteText = dogName
      ? `Custom Name Patch: "${dogName}"`
      : '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: noteText })
    }).catch(err => console.error('Error updating cart note:', err));
  }
})();